module.exports = __webpack_public_path__ + "static/media/l_dot_16.8fa8f60b.png";